import { Component, input } from '@angular/core';
import type { SwapPoint } from '../../../../../fleet/common/interfaces/technical-point';
import { SwapVehicleType } from '../../../enums/swap/swap-vehicle-type';
import type { Swap } from '../../../interfaces/swap/swap';
import { SwapModalSummaryItemComponent } from './swap-modal-summary-item/swap-modal-summary-item.component';

@Component({
  selector: 'app-swap-modal-summary',
  imports: [SwapModalSummaryItemComponent],
  templateUrl: './swap-modal-summary.component.html',
  styleUrl: './swap-modal-summary.component.scss',
})
export class SwapModalSummaryComponent {
  public readonly swap = input.required<Swap>();
  public readonly technicalPoints = input.required<SwapPoint[]>();
  public readonly isDouble = input.required<boolean>();

  protected readonly SwapVehicleType = SwapVehicleType;
}
